import React, { useEffect, useState } from "react";
import Button from "./Button";

const WantProductEditModal = ({ product, onClose, onSave }) => {
  const [form, setForm] = useState({
    name: "",
    budget: "",
    location: "",
    description: "",
    contact_phone: "",
    contact_whatsapp: "",
    is_active: true,
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (product) {
      setForm({
        name: product.name || "",
        budget: product.budget || "",
        location: product.location || "Swellendam",
        description: product.description || "",
        contact_phone: product.contact_phone || "",
        contact_whatsapp: product.contact_whatsapp || "",
        is_active:
          product.is_active !== undefined
            ? product.is_active
            : true,
      });
    }
  }, [product]);

  if (!product) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleActiveChange = (e) => {
    setForm((prev) => ({
      ...prev,
      is_active: e.target.value === "true",
    }));
  };

  const handleSubmit = async () => {
    try {
      setSaving(true);

      await onSave(product.id, {
        name: form.name,
        budget: form.budget,
        location: form.location,
        description: form.description,
        contact_phone: form.contact_phone,
        contact_whatsapp: form.contact_whatsapp,
        is_active: form.is_active,
      });

    } catch (error) {
      console.error("Error saving wanted product:", error);
      alert("Something went wrong while saving the wanted listing.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">

      <div className="bg-white w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-lg p-6 shadow-xl">

        <h2 className="text-xl font-bold mb-5">
          Edit Wanted Listing
        </h2>

        <div className="space-y-5">

          {/* STATUS */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>

            <select
              value={form.is_active ? "true" : "false"}
              onChange={handleActiveChange}
              className="w-full border p-2 rounded"
            >
              <option value="true">
                Active
              </option>

              <option value="false">
                Fulfilled
              </option>
            </select>
          </div>

          {/* NAME */}
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="What are you looking for?"
          />

          {/* BUDGET */}
          <input
            name="budget"
            value={form.budget}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Budget"
            type="number"
          />

          {/* LOCATION */}
          <input
            name="location"
            value={form.location}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Location"
          />

          {/* DESCRIPTION */}
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Description"
            rows="4"
          />

          {/* PHONE NUMBER */}
          <input
            name="contact_phone"
            value={form.contact_phone}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Phone Number"
            type="tel"
          />

          {/* WHATSAPP NUMBER */}
          <input
            name="contact_whatsapp"
            value={form.contact_whatsapp}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="WhatsApp Number"
            type="tel"
          />

        </div>

        {/* ACTIONS */}
        <div className="flex justify-end gap-2 mt-6">

          <Button
            variant="outline"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </Button>

        </div>

      </div>

    </div>
  );
};

export default WantProductEditModal;